import { Injectable } from '@angular/core';
import { BaseService } from '../api-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { apiPath } from '../const';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ShipmentsService extends BaseService {

  constructor(public httpClient: HttpClient, public Alerts: MatSnackBar,
    public datepipe: DatePipe) {
    super(httpClient);
  }

  getAllShipments(data) {
    data.startDate = this.datepipe.transform(data.startDate, "yyyy-MM-dd");
    data.endDate = this.datepipe.transform(data.endDate, "yyyy-MM-dd");
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getShipments, data)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
  getAllSaleOrders() {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getSaleOrders)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  
  getAllSaleOrdersPagination(model:any) {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.post(apiPath.getSaleOrdersPag,model)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  
  getAllProductDimensionsByProc(model:any) {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.post(apiPath.getAllProdcutDimensionsByProc,model)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  getSingleProductDimensions(id) {
    let params = new HttpParams().set('id', id)
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getSingleProductDimensions, params)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  createProductDimensions(data) {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        this.Alerts.open(data.data.message, 'ok');
        return true
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.post(apiPath.addEditProdcutDimensions, data)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
  
  getAllPackingSlips(model:any) {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.post(apiPath.getPackingSlips,model)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  getAllRateSetup() {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getRateSetups)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  activeInacticeRateStatus(id, status) {
    let params = new HttpParams().set('id', id).set('status', status)
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.activeInactiveRateSetup,params)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  getShipmentbyID(id) {
    let params = new HttpParams().set('shipmentId', id)
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getShipmentbyID, params)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
  
  getRateSetupById(id) {
    let params = new HttpParams().set('rateSetupId', id)
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getRateSetupbyID, params)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  getBoxSizes() {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getBoxSizes)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  getStoreAddress() {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open('Internal Server Error', 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.getStoreAddress)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  printDocument(url) {
    let params = new HttpParams().set('url', url)
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.get(apiPath.printDocument,params)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  createShipment(data) {
    data.dateOfShipment = this.datepipe.transform(data.dateOfShipment, "yyyy-MM-dd");
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.post(apiPath.createShipment, data)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
  
  createRateSetup(data) {
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        this.Alerts.open(data.data.message, 'ok');
        return true
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.post(apiPath.createRateSetup, data)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }

  getRates(data) {
    data.dateOfShipment = this.datepipe.transform(data.dateOfShipment, "yyyy-MM-dd");
    let onSuccess = (value) => {
      let data = null
      value.subscribe(obj => {
        data = obj
      })
      if (data.data.success) {
        return data.data.data;
      }
      else {
        this.Alerts.open(data.data.message, 'ok');
        return false
      }
    }
    return this.service(this.post(apiPath.getRates, data)).pipe(
      map(value => this.processPayload(value)),
      map(onSuccess)
    );
  }
}
